/**
 * Sends the browser to the card processor's page (a hosted payment page or a 3-D Secure step). One function, so the
 * suites can replace the navigation (happy-dom has no processor to go to) and nothing else here touches `location`.
 */
export function goToPaymentPage(url: string): void {
  globalThis.location.assign(url);
}
